import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Eye, EyeOff } from 'lucide-react';

export default function PasswordInput({
  value,
  onChange,
  placeholder,
  autoComplete = 'current-password',
  required,
  id,
  'data-testid': testId,
  className = '',
  toggleTestId,
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        data-testid={testId}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Piilota salasana' : 'Näytä salasana'}
        title={show ? 'Piilota salasana' : 'Näytä salasana'}
        data-testid={toggleTestId || 'password-toggle'}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full text-[#6A6D66] hover:text-[#1C1C1A] hover:bg-[#F4F6F3] flex items-center justify-center transition-colors"
      >
        {show ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </div>
  );
}
